// extracted by mini-css-extract-plugin
module.exports = {"item":"SelectedMenuItem-item-3Eq5f","isSelected":"SelectedMenuItem-isSelected-3os2V","isNotSelected":"SelectedMenuItem-isNotSelected-Sypjw"};